module.exports = __webpack_public_path__ + "img/feature_payment.86467718.png";